// Package imports
import React from 'react';

// CSS imports
import './FullPageSpinner.css';

// Component imports
import Spinner from '../spinner/Spinner';
import { Portal } from 'react-portal';

const FullPageSpinner: React.FC = () => {
  return (
    <Portal>
      <div className={'FullPageSpinner'}>
        <Spinner isLoading={true} color='#FFFFFF' />
      </div>
    </Portal>
  );
};

export default FullPageSpinner;
